export default {"src":"/_next/static/media/pof-logo.b4af2e41.svg","height":72,"width":133,"blurWidth":0,"blurHeight":0};